import React from "react";

interface ISuccessIconProps {
  hidden?: boolean;
  className?: string;
}

const SuccessIcon = ({ hidden = false, className = "" }: ISuccessIconProps) => {
  const color = hidden ? 'white' : '#25B900';

  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.4"
        y="0.9"
        width="13.2"
        height="13.2"
        rx="6.6"
        fill="white"
        stroke={color}
        strokeWidth="1"
      />
      <path
        d="M2.9165 7.75386L5.51182 10.3492L11.0832 4.77783"
        stroke={color}
        fill={color}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default SuccessIcon;
